import React, { Component, Fragment } from 'react'
import { connect } from 'react-redux'
import SideSearchbar from '../../components/SideSearchbar/'
import { GetConsultantsFunction, EditConsultationFunction, CreateConsultantFunction, DeleteConsultantFunction } from './consultantAction'
import { Container, DialogContentText, DialogContent, DialogTitle, DialogActions, Dialog, Grid, Button, TextField } from '@material-ui/core';
import OverLoader from '../../components/common/loader';
import '../../App.css'
import isEmpty from 'lodash.isempty';
import { LogoutAction } from '../../actions';
import {
  Prompt
} from "react-router-dom";

class ConsultantFunction extends Component {

  constructor(props) {
    super(props);
    this.state = {
      listData: [],
      consultantField: '',
      consultantFieldError: false,
      consultantID: '',
      editMode: false,
      newConsultant: '',
      editedConsultant: '',
      deleteConsultant: '',
      errorMessage: '',
      errorField: false,
      isBlocking: false,
      isDeleteContactDialogOpen: false,
      accessErrorDialog: false
    }

    this.baseState = this.state;
    this.textInput = React.createRef();

  }

  focusTextInput = () => {
    const access_rights = JSON.parse(localStorage.getItem('access_right'))
    const token = localStorage.getItem('access-token')

    if (Number(access_rights.consultant_functions) === 2 && token !== null)
      this.textInput.current.focus();
  }

  componentDidMount = () => {
    const { GetConsultantsFunction } = this.props
    GetConsultantsFunction()
  }
  UNSAFE_componentWillReceiveProps = (nextProps) => {
    const { consultant_list, access_error, new_consultant, edited_function, delete_success, error_validation, message_valid } = this.props
    const { consultantID } = this.state
    if (nextProps.consultant_list !== consultant_list) {
      this.setState({ listData: nextProps.consultant_list })
    }
    else if (nextProps.new_consultant !== new_consultant) {
      this.setState({
        newBranch: nextProps.new_consultant, isBlocking: false, consultantID: nextProps.new_consultant.id, editMode: true
      })
    }
    else if (nextProps.edited_function !== edited_function) {
      this.setState({
        editedBranch: nextProps.edited_function, isBlocking: false
      })
    } else if (nextProps.delete_success !== delete_success) {
      this.setState({
        deleteConsultant: consultantID, consultantField: '', isBlocking: false, editMode: false
      })
    }
    else if (nextProps.error_validation !== error_validation || nextProps.message_valid !== message_valid) {
      this.setState({ errorMessage: nextProps.error_validation, errorField: true })
    }
    else if (nextProps.access_error !== access_error) {
      this.setState({ accessErrorDialog: true })
    }
  }

  getConsultantData = (item) => {
    const { isBlocking } = this.state
    if (!isBlocking) {
      this.setState({ consultantID: item.id, errorMessage: '', errorField: false, consultantField: item.name, editMode: true })
      setTimeout(() => {
        this.focusTextInput()
      }, 100)
    }
    else {
      let retVal = window.confirm("Ihre Änderungen wurden nicht gepeichert. Möchten Sie trotzdem fortfahren?");

      if (retVal === true) {
        this.setState({ isBlocking: false }, () => this.getConsultantData(item))
      } else {
        this.setState({ isBlocking: false }, () => setTimeout(() => {
          this.setState({ isBlocking: true })
        }, 1000))
      }
    }
  }

  editConsultantFunction = () => {
    const { consultantID, consultantField } = this.state
    const { EditConsultationFunction } = this.props
    EditConsultationFunction(consultantID, consultantField)
  }

  createConsultantFunction = () => {
    const { CreateConsultantFunction } = this.props
    const { consultantField } = this.state
    if (consultantField !== '') {
      CreateConsultantFunction(consultantField)
    } else {
      this.setState({ consultantFieldError: true })
    }
  }
  deletaConsultantFunction = () => {
    const { DeleteConsultantFunction } = this.props
    const { consultantID } = this.state
    DeleteConsultantFunction(consultantID)
    this.setState({ isDeleteContactDialogOpen: false })
    setTimeout(() => {
      this.focusTextInput()
    }, 100)
  }

  openDeleteDialog = () => {
    this.setState({ isDeleteContactDialogOpen: true })
  }
  closeDeleteContactDialog = () => {
    this.setState({ isDeleteContactDialogOpen: false })

  }

  resetForm = () => {
    this.setState({
      consultantField: '', errorMessage: '', errorField: false, isBlocking: false, consultantID: '', editMode: false
    })
    setTimeout(() => {
      this.focusTextInput()
    }, 200)
  }

  render() {
    const { deleteConsultant, isBlocking, accessErrorDialog, errorField, errorMessage, isDeleteContactDialogOpen, editMode, listData, consultantField, newBranch, editedBranch } = this.state
    const { isloading, access_error } = this.props
    const access_rights = JSON.parse(localStorage.getItem('access_right'))
    const token = localStorage.getItem('access-token')
    if (token === null) {
      this.props.LogoutAction()
    }
    return (
      <div>
        {isloading && <OverLoader />}
        <Container maxWidth="xl">
          <Grid container spacing={3} className="mainBlock">
            {isEmpty(errorMessage.message) ?
              <Fragment>
                <Grid item md={3} sm={4} xs={12}>
                  <div className="leftSide">
                    <SideSearchbar
                      tittle={"Neue Funktion"}
                      listData={listData}
                      newList={newBranch}
                      editedList={editedBranch}
                      deleteList={deleteConsultant}
                      getDataOfSelectedItemFunc={this.getConsultantData}
                      createNewListFunc={this.resetForm}
                      isRight={Number(access_rights.consultant_functions)}

                    />
                  </div>
                </Grid>
                <Grid item md={9} sm={8} xs={12}
                  className={`${Number(access_rights.consultant_functions) === 1 ? "disableALlFields" : ""}`}
                >
                  <Prompt
                    when={isBlocking}
                    message={location =>
                      `Ihre Änderungen wurden nicht gepeichert. Möchten Sie trotzdem fortfahren? `
                    }
                  />
                  <div className="rightBlock liproCard">
                    <div className="mb2">
                      <label className="mb1">Funktion</label>
                      <TextField
                        inputProps={{
                          maxLength: 40
                        }}
                        helperText={errorField ? "Funktion " + errorMessage.name : ''} error={errorField ? true : false} autoFocus
                        inputRef={this.textInput} size="small" value={consultantField} className="innerInput"
                        onChange={(e) => {
                          this.setState({
                            consultantField: e.target.value, errorField: false, isBlocking: true,
                          })
                        }} variant="outlined" />
                    </div>
                    {Number(access_rights.consultant_functions) !== 1 &&
                      <div className="actionBtn">
                        {editMode ?
                          <Button variant="outlined" color="primary" onClick={() => { this.editConsultantFunction() }} >Speichern</Button>
                          :
                          <Button variant="outlined" color="primary" onClick={() => { this.createConsultantFunction() }} >Hinzufügen</Button>
                        }
                        {editMode &&
                          <Button variant="outlined" color="primary" onClick={() => { this.openDeleteDialog() }} >Löschen</Button>
                        }
                      </div>
                    }
                    <Dialog
                      open={isDeleteContactDialogOpen}
                    >
                      <DialogTitle>Funktion löschen</DialogTitle>
                      <DialogContent>
                        <DialogContentText >
                          Sind Sie sicher?
              </DialogContentText>
                      </DialogContent>
                      <DialogActions>
                        <Button onClick={this.deletaConsultantFunction} size="small" variant="outlined" color="primary" autoFocus>
                          Bestätigen
              </Button>
                        <Button onClick={this.closeDeleteContactDialog} size="small" variant="outlined" color="secondary">
                          Abbrechen
              </Button>
                      </DialogActions>
                    </Dialog>

                    <Dialog
                      open={accessErrorDialog}
                    >
                      <DialogTitle>Beraterfunktionen</DialogTitle>
                      <DialogContent>
                        <DialogContentText >
                          {access_error && access_error.message}
                        </DialogContentText>
                      </DialogContent>
                      <DialogActions>
                        <Button onClick={() => this.setState({ accessErrorDialog: false })} size="small" variant="outlined" color="secondary" >
                          Abbrechen
              </Button>
                      </DialogActions>
                    </Dialog>
                  </div>
                </Grid>
              </Fragment>
              :
              <Grid item md={12} sm={12} xs={12}>
                <div className="rightBlock rightBlock-bgWhite user-system">
                  <h3>{errorMessage.message}</h3>
                </div>
              </Grid>
            }
          </Grid>
        </Container>
      </div>
    )
  }
}

const mapStateToProps = ({ consultant }) => {
  return {
    isloading: consultant.loading,
    consultant_list: consultant.consultant_list,
    message_valid: consultant.message_valid,
    new_consultant: consultant.new_consultant,
    edited_function: consultant.edited_function,
    delete_success: consultant.success,
    error_validation: consultant.error_message,
    access_error: consultant.access_error,

  }
};

const mapDispatchToProps = dispatch => {
  return {
    // dispatching actions
    GetConsultantsFunction: () => dispatch(GetConsultantsFunction()),
    EditConsultationFunction: (id, name) => dispatch(EditConsultationFunction(id, name)),
    CreateConsultantFunction: (id, name) => dispatch(CreateConsultantFunction(id, name)),
    DeleteConsultantFunction: (id) => dispatch(DeleteConsultantFunction(id)),
    LogoutAction: () => dispatch(LogoutAction()),
  }
}


export default connect(mapStateToProps, mapDispatchToProps)(ConsultantFunction)